import { combineReducers } from "redux";

import counterReducer from "../features/counter/counterSlice";
import authReducer from "../features/auth/authSlice";
import dealerReducer from "../features/dealer/dealerSlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";
import paymentReducer from "../features/adyen/paymentSlice";
import transactionSettingsReducer from "../features/settings/transactionsettings.slice";
import signatureReducer from "../features/nonPaymentSignature/signatureSlice";
import { authApi } from "../services/API/authApiSlice";
import { dashboardApi } from "../services/API/dashboardApiSlice";
import { transactionApi } from "../services/API/transactionsApiSlice";
import { userApi } from "../services/API/userApiSlice";
import { vaultedCardApi } from "../services/API/vaultedCardApiSlice";
import { settingsApi } from "../services/API/settingsApiSlice";
import { validateSignature } from "../services/API/signatureApiSlice";
import { SwitchPaymentGateway } from "../services/API/SwitchPaymentGatewayApiSlice";
import { reportApi } from "../services/API/reportApiSlice";
import { dealerSurchargeApi } from "../services/API/surchargeApiSlice";
import { commonApiSlice } from "../services/API/commonApiSlice";
import { webHookApiSlice } from "../services/API/webHookApiSlice";
import { perseusPayApi } from "../services/API/perseusPayAPISlice";
import { customFieldApi } from "../services/API/customFieldApiSlice";
import { dealerImportApi } from "../services/API/dealerImportApiSlice";
import { achEnrollmentPublicApi } from "../services/API/achEnrollmentPublicApiSlice";

export default combineReducers({
  counter: counterReducer,
  auth: authReducer,
  dashboard: dashboardReducer,
  dealer: dealerReducer,
  payment: paymentReducer,
  transactionSettings: transactionSettingsReducer,
  signature: signatureReducer,

  [authApi.reducerPath]: authApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [transactionApi.reducerPath]: transactionApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [vaultedCardApi.reducerPath]: vaultedCardApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [validateSignature.reducerPath]: validateSignature.reducer,
  [SwitchPaymentGateway.reducerPath]: SwitchPaymentGateway.reducer,
  [reportApi.reducerPath]: reportApi.reducer,
  [dealerSurchargeApi.reducerPath]: dealerSurchargeApi.reducer,
  [perseusPayApi.reducerPath]: perseusPayApi.reducer,
  [commonApiSlice.reducerPath]: commonApiSlice.reducer,
  [webHookApiSlice.reducerPath]: webHookApiSlice.reducer,
  [customFieldApi.reducerPath]: customFieldApi.reducer,
  [dealerImportApi.reducerPath]: dealerImportApi.reducer,
  [achEnrollmentPublicApi.reducerPath]: achEnrollmentPublicApi.reducer,
});
